import React from 'react';
import ReactDOM from 'react-dom';
import { MsalProvider, useIsAuthenticated } from '@azure/msal-react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Theme } from '@zurich-base-ui/ui.theme';
import reportWebVitals from './reportWebVitals';
import { Toast } from '@zurich-base-ui/components.toast';
import './index.scss';
import {
  Routes,
  handleLogoutMsal,
  http,
  msalAuth,
  store,
  useAppSelector,
  useHttpAuthInterceptors
} from 'app';
import config from 'config';
import { getHomeAccountId } from 'app/redux';

const App: React.FC = () => {
  const hmeAccountId = useAppSelector(getHomeAccountId);
  http.setBaseUrl(config.APP.API);

  const onInactive = (ms: number, callback: () => void): void => {
    let wait = setTimeout(callback, ms);

    for (const evt of ['click', 'touchstart', 'mousemove']) {
      document.addEventListener(evt, () => {
        clearTimeout(wait);
        wait = setTimeout(callback, ms);
      });
    }
  };

  onInactive(14400000, () => handleLogoutMsal(hmeAccountId));

  let isAuthenticated = useIsAuthenticated();
  if (config.AUTH.ENABLED === 'false') {
    isAuthenticated = true;
  }

  useHttpAuthInterceptors();

  const routing = useRoutes(Routes(isAuthenticated));

  return <>{routing}</>;
};

const container = document.getElementById('root')!;

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <MsalProvider instance={msalAuth}>
    <Provider store={store}>
      <BrowserRouter>
        <Toast autoclose={5500} />
        <Theme>
          <App />
        </Theme>
      </BrowserRouter>
    </Provider>
  </MsalProvider>,
  container
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
